"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcAvatarInitialsColors = exports.BcAvatarIllustrationsName = exports.BcAvatarSize = void 0;
var BcAvatarSize;
(function (BcAvatarSize) {
    BcAvatarSize["tiny"] = "tiny";
    BcAvatarSize["small"] = "small";
    BcAvatarSize["medium"] = "medium";
    BcAvatarSize["large"] = "large";
    BcAvatarSize["xlarge"] = "xlarge";
})(BcAvatarSize || (exports.BcAvatarSize = BcAvatarSize = {}));
var BcAvatarIllustrationsName;
(function (BcAvatarIllustrationsName) {
    BcAvatarIllustrationsName[BcAvatarIllustrationsName["il-avatar-old-man"] = 0] = "il-avatar-old-man";
    BcAvatarIllustrationsName[BcAvatarIllustrationsName["il-avatar-home"] = 1] = "il-avatar-home";
    BcAvatarIllustrationsName[BcAvatarIllustrationsName["il-avatar-lollipop"] = 2] = "il-avatar-lollipop";
    BcAvatarIllustrationsName[BcAvatarIllustrationsName["il-avatar-earring"] = 3] = "il-avatar-earring";
})(BcAvatarIllustrationsName || (exports.BcAvatarIllustrationsName = BcAvatarIllustrationsName = {}));
var BcAvatarInitialsColors;
(function (BcAvatarInitialsColors) {
    BcAvatarInitialsColors["macondo"] = "macondo";
    BcAvatarInitialsColors["andino"] = "andino";
    BcAvatarInitialsColors["orquidea"] = "orquidea";
    BcAvatarInitialsColors["alba"] = "alba";
    BcAvatarInitialsColors["flamenco"] = "flamenco";
    BcAvatarInitialsColors["caribe"] = "caribe";
})(BcAvatarInitialsColors || (exports.BcAvatarInitialsColors = BcAvatarInitialsColors = {}));
